export default __webpack_public_path__ + "static/media/armenia.ccdc71ac.png";